<script>
    /*
      Nivoi pristupa aplikaciji:        
      >> Low Access Group
          ~ Level 1 - Promoter (Promoter)
          ~ Level 2 - 
          ~ Level 3 - Konobar (Waiter)
          ~ Level 4 - Hostesa (Hostess) - ReadOnly  (!!! VAZNO - devojke na rezervacijama mogu da menjaju sadrzaj samo na dan kada se dogadjaj odigrava, zbog toga neko sa visim nivoom pristupa mora da im dozvoli menjanje sadrzaja rucno)
                      - To znaci da kada neko hoce da odobri pristup hostesama da menjaju sadrzaj (cekiraju rezervacije, zamene stolove, itd..), onda treba da spusti minimalni nivo pristup za taj deo (Level 5 se spusta na Level 4)
      >> Medium Access Group
          ~ Level 5 - 
          ~ Level 6 - Devojka na rezervacijama (Reservation Manager)
          ~ Level 7 - 
      >> High Access Group
          ~ Level 8 - Menadzer lokala (Club Manager)
          ~ Level 9 - Jokara, Mladen, Milos (ljudi koji imaju pristup poverljivim informacijama) (Owner)
          ~ Level 10 - Ima pristup celom sadrzaju (brise, pise, menja sifre..) (Master Admin)
      =============================================================================
                                      View            Edit            Delete          Create
      1. Buduci dogadjaji             >= Level 1      >= Level 5      >= Level 8      >= Level 8
      2. Arhivirani dogadjaji         >= Level 8      >= Level 8      >= Level 8      >= Level 8
      3. Stalni gosti                 >= Level 5      >= Level 5      >= Level 8      >= Level 5
      4. Stalni gosti - potrosnja     >= Level 8      >= Level 8      >= Level 8      >= Level 8
      5. Konobar                      >= Level 8      >= Level 8      >= Level 8      >= Level 8
      6. Tipovi rezervacija           >= Level 8      >= Level 8      >= Level 8      >= Level 8
      7. Administratori               >= Level 10     >= Level 10     >= Level 10     >= Level 10
      8. Istorija izmena (Logs)       >= Level 8      >= Level 8      >= Level 8      >= Level 8
    */
export default {
  data () {
    return {
      testMsg: 'MixinAccessChecker',  
      // Firebase User/Admin info
      // currentUserData: null,
      // // firebaseDB_User: {
      // //   // Firebase account
      // //   currentUser: null,
      // //   // User specific details (first name, last name, phone..)
      // //   userDetails: null,
      // //   isOnline: false
      // // },
    }
  },
  // watch: {
  //   'currentUserData' : function (newValue){
  //     console.log('watch changed -> currentUserData: ' + JSON.stringify(this.currentUserData, null, 2));
  //   } 
  // },
  methods: {
    glMixin_userAccessCheck: function (inputCurrentFirebaseUser, inputConditionLevel){
      var returnState = false;
      if (inputCurrentFirebaseUser && inputCurrentFirebaseUser.userDetails && inputCurrentFirebaseUser.userDetails.accessRoleKey && inputConditionLevel){
        var inputUserAccessRoleKey = inputCurrentFirebaseUser.userDetails.accessRoleKey;
        if ( typeof inputConditionLevel === 'string' || inputConditionLevel instanceof String ){
          //use this logic when we pass 'inputConditionLevel' as group string (high, medium, low..)
          //console.log('check group: ' + inputConditionLevel + ', inputUserAccessRoleKey: ' + inputUserAccessRoleKey);
          var groupCondition = inputConditionLevel.toLowerCase();
          if ( (groupCondition === 'low' || groupCondition === 'l') && inputUserAccessRoleKey >=1){
            returnState = true;
          }else if ( (groupCondition === 'medium' || groupCondition === 'm') && inputUserAccessRoleKey >=5){
            returnState = true;
          }else if ((groupCondition === 'high' || groupCondition === 'h') && inputUserAccessRoleKey >=8){
            returnState = true;
          }
        }else{
          //console.log('check number: ' + inputConditionLevel + ', inputUserAccessRoleKey: ' + inputUserAccessRoleKey);
          // use this logic when we pass 'inputConditionLevel' as exact level number (1,4,6,7,8..)
          if (inputUserAccessRoleKey >= inputConditionLevel){
            returnState = true;
          }
        }
      }
      return returnState;
    },    
    // glMixin_userAccessCheck: function (inputConditionLevel){
    //   console.log('glMixin_userAccessCheck: ' + inputConditionLevel);
    //   console.log('this.currentUserData: ' + this.currentUserData);
    //   var returnState = false;
    //   if (this.currentUserData && this.currentUserData.userDetails && this.currentUserData.userDetails.accessRoleKey && inputConditionLevel){
    //     var inputUserAccessRoleKey = this.currentUserData.userDetails.accessRoleKey;
    //     console.log('inputUserAccessRoleKey: ' + inputUserAccessRoleKey);
    //     if ( typeof inputConditionLevel === 'string' || inputConditionLevel instanceof String ){
    //       //use this logic when we pass 'inputConditionLevel' as group string (high, medium, low..)
    //       console.log('check group: ' + inputConditionLevel);
    //       var groupCondition = inputConditionLevel.toLowerCase();
    //       if ( (groupCondition === 'low' || groupCondition === 'l') && inputUserAccessRoleKey >=1){
    //         returnState = true;
    //       }else if ( (groupCondition === 'medium' || groupCondition === 'm') && inputUserAccessRoleKey >=5){
    //         returnState = true;
    //       }else if ((groupCondition === 'high' || groupCondition === 'h') && inputUserAccessRoleKey >=8){
    //         returnState = true;
    //       }
    //     }else{
    //       console.log('check number: ' + inputConditionLevel);
    //       // use this logic when we pass 'inputConditionLevel' as exact level number (1,4,6,7,8..)
    //       if (inputUserAccessRoleKey >= inputConditionLevel){
    //         returnState = true;
    //       }
    //     }
    //   }
    //   return returnState;
    // },    
    // glMixin_updateFirebaseUserData: function (inputNewData){
    //   console.log('glMixin_updateFirebaseUserData: ' + JSON.stringify(inputNewData, null, 2));
    //   this.currentUserData = inputNewData;
    // }
  },
  created () {
    //console.log('~ created- MixinAccessChecker!');
  },  
  mounted () {
    //console.log('~ mounted - MixinAccessChecker!');
  }  
};
</script>



// WEBPACK FOOTER //
// src/components/helpers/MixinAccessChecker.vue